var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var msp3ScopedTheme = {
    type: 'michelinDark',
    background: {
        default: '#2D5FB9',
        paper: '#27509B',
    },
    action: {
        active: 'rgba(255, 255, 255, 0.54)',
        hover: 'rgba(255, 255, 255, 0.16)',
    },
    default: {
        main: '#FCE500'
    },
};
export var badgeSidebarTheme = __assign(__assign({}, msp3ScopedTheme), { default: { main: '#21417d' } });
// No overrides needed beyond the base — aliased for clarity and future extension
export var headerTheme = __assign({}, msp3ScopedTheme);
export var appsMenuTheme = __assign({}, msp3ScopedTheme);
//# sourceMappingURL=scopedThemes.js.map